import script from "./form-item-wrapper-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./form-item-wrapper-ly.vue?vue&type=script&setup=true&lang=js"

import "./form-item-wrapper-ly.vue?vue&type=style&index=0&id=1ee27a60&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ee27a60"]])

export default __exports__